import axios from 'axios';

export const getAllLiveCall = ({ url, signal }) => {
  return axios.get(url, { signal });
};
